export function isExternalLink(url) {
  return /^https?/.test(url);
}
